import { loadScript } from 'core/services/loadScript';
import { isFunction } from 'lodash-es';
import React, { useEffect, useState } from 'react';

export interface IProps {
    script: string;
    children?: React.ReactNode | (() => React.ReactNode);
    onLoad?: () => void;
}

export const WidgetLazyLoader: React.FC<IProps> = ({ children, onLoad, script }) => {
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        (async () => {
            if (scriptLoaded) {
                return;
            }
            await loadScript(script, script);
            setScriptLoaded(true);

            if (onLoad) {
                onLoad();
            }
        })();
    }, [onLoad, script, scriptLoaded]);

    if (!scriptLoaded) {
        return null;
    }
    if (isFunction(children)) {
        return <>{children()}</>;
    }
    return (
        <>{children}</>
    );
};
